import React, { FC } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
}

const Date: FC<Props> = ({ title }) => {
  return (
    <Box width="full" gap="s4">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {title}
      </Text.Normal>
      <Box
        background="grey000White"
        paddingY="s8"
        paddingX="s12"
        borderRadius={{ all: 'abs008' }}
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
      >
        <Text.Normal color="grey800">10/05/1990</Text.Normal>
        <Icon.Small icon="caret-down" color="grey800" />
      </Box>
    </Box>
  )
}

export default Date
